import { useQuery } from "@tanstack/react-query";

import { getTrophyCaseData } from "../../../../api/getTrophyCaseData";
import { useSalesContext } from "../../../../sales-context/SalesContext";

export const useTrophyCaseData = () => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: ["TrophyCaseData"],
        queryFn: async () => getTrophyCaseData(apiClients.gamification),
        retry: 1,
    });
    return { data, isLoading, isError };
};
